import { IToolbarItem } from "./IToolbarItem";
import { ToolbarMenu } from "./ToolbarMenu";
import { Toolbar } from "../Toolbar";

export class ToolbarMenuItem implements IToolbarItem {

    public value: string;
    public id: string;

    public constructor(private control: HTMLElement, private menu: ToolbarMenu, private toolbar: Toolbar) {
        if (control.hasAttribute("data-value")) {
            this.value = control.getAttribute("data-value");
        }
        if (control.hasAttribute("data-id")) {
            this.id = control.getAttribute("data-id");
        }
    }

    public enable(enable: boolean) {
        if (enable) {
            this.control.classList.remove("disabled");
        }
        else {
            this.control.classList.add("disabled");
        }
    }
}
